export default __webpack_public_path__ + "static/media/Banner - AirStrapz - Cobalt Blue.39b9d1fa.jpg";